import React, { useState } from 'react';
import { Calendar, MapPin, TrendingUp, ChevronDown } from 'lucide-react';
import { portfolioData } from '../data/portfolio';

const Experience = () => {
  const { experiences } = portfolioData;
  const [selectedJob, setSelectedJob] = useState(experiences[0]);
  const [expandedMobile, setExpandedMobile] = useState(0); // For mobile accordion

  return (
    <section id="experience" className="py-20 md:py-32 px-6 bg-[#0f0f0f]">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Work Experience</h2>
          <div className="w-20 h-1 bg-[#00b4d8]"></div>
        </div>

        {/* Mobile Layout - Accordion Style */}
        <div className="md:hidden space-y-4">
          {experiences.map((job, index) => (
            <div 
              key={index}
              className={`border rounded-lg overflow-hidden transition-all duration-300 ${
                expandedMobile === index 
                  ? 'border-[#00b4d8] bg-[#151515]' 
                  : 'border-white/10 bg-[#0f0f0f]'
              }`}
            >
              {/* Accordion Header */}
              <button
                onClick={() => setExpandedMobile(expandedMobile === index ? -1 : index)}
                className="w-full p-4 flex items-center justify-between text-left"
              >
                <div>
                  <div className="font-semibold text-white">{job.company}</div>
                  <div className="text-sm text-[#00b4d8]">{job.title}</div>
                  <div className="text-xs text-[#666666] mt-1">{job.period}</div>
                </div>
                <ChevronDown 
                  size={20} 
                  className={`text-[#00b4d8] transition-transform duration-300 ${
                    expandedMobile === index ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {/* Accordion Content */}
              <div className={`overflow-hidden transition-all duration-300 ${
                expandedMobile === index ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="px-4 pb-4 border-t border-white/10 pt-4">
                  {/* Description */}
                  {/* <p className="text-[#a0a0a0] mb-4 text-sm leading-relaxed">
                    {job.description}
                  </p> */}

                  {/* Key Achievements */}
                  <div>
                    {/* <h4 className="text-xs font-semibold text-white mb-3 flex items-center gap-2">
                      <TrendingUp size={14} className="text-[#00b4d8]" />
                      Key Achievements
                    </h4> */}
                    <ul className="space-y-2">
                      {job.achievements.map((achievement, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-[#a0a0a0] text-sm">
                          <span className="text-[#00b4d8] mt-0.5 text-xs">▸</span>
                          <span>{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop Layout - Original Side by Side */}
        <div className="hidden md:grid md:grid-cols-3 gap-8">
          {/* Left Side - Company List */}
          <div className="md:col-span-1">
            <div className="space-y-2">
              {experiences.map((job, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedJob(job)}
                  className={`w-full text-left px-4 py-4 rounded-lg transition-all duration-300 border-l-4 ${
                    selectedJob.company === job.company
                      ? 'bg-[#151515] border-[#00b4d8] text-white'
                      : 'bg-transparent border-white/10 text-[#a0a0a0] hover:bg-[#151515] hover:border-[#00b4d8]/50'
                  }`}
                >
                  <div className="font-semibold text-sm mb-1">{job.company}</div>
                  <div className="text-xs text-[#666666]">{job.period}</div>
                </button>
              ))}
            </div>
          </div>

          {/* Right Side - Job Details */}
          <div className="md:col-span-2">
            <div className="bg-[#151515] border border-white/10 rounded-lg p-8">
              {/* Job Header */}
              <div className="mb-6">
                <h3 className="text-2xl font-bold mb-3">{selectedJob.title}</h3>
                <div className="flex flex-wrap gap-4 text-sm text-[#a0a0a0]">
                  <div className="flex items-center gap-2">
                    <MapPin size={16} className="text-[#00b4d8]" />
                    <span>{selectedJob.company}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar size={16} className="text-[#00b4d8]" />
                    <span>{selectedJob.period}</span>
                  </div>
                </div>
              </div>

              {/* Description */}
              {/* <p className="text-[#a0a0a0] mb-6 leading-relaxed">
                {selectedJob.description}
              </p> */}

              {/* Key Achievements */}
              <div>
                {/* <h4 className="text-sm font-semibold text-white mb-4 flex items-center gap-2">
                  <TrendingUp size={16} className="text-[#00b4d8]" />
                  Key Achievements
                </h4> */}
                <ul className="space-y-3">
                  {selectedJob.achievements.map((achievement, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-[#a0a0a0]">
                      <span className="text-[#00b4d8] mt-1.5 text-sm">▸</span>
                      <span>{achievement}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
